import {
  GRAMMAR_CHECK_SLUG,
  HOMEPAGE_SLUG,
  PAID_HOMEPAGE_SLUG,
  PAID_STUDENTS_SLUG,
  PLAGIARISM_CHECKER_SLUG,
  PAID_AI_SLUG,
  DESKTOP_SLUG,
  PAID_CITATIONS_SLUG,
  PARAPHRASING_TOOL_SLUG,
  SENTENCE_CHECKER_SLUG,
  ESSAY_CHECKER_SLUG,
  PAID_PARAPHRASING_TOOL_SLUG,
  AI_DETECTOR_SLUG,
  AI_HUMANIZER_SLUG,
} from '@lib/constants'

export const isPlagiarismCheckerPage = (pageSlug: string): boolean => pageSlug === 'plagiarism-checker'

export const isFrequentlyVisitedPageByReturningUsers = (pageSlug: string) => {
  return new Set([
    HOMEPAGE_SLUG,
    GRAMMAR_CHECK_SLUG,
    PAID_HOMEPAGE_SLUG,
    PLAGIARISM_CHECKER_SLUG,
    PAID_STUDENTS_SLUG,
    PAID_AI_SLUG,
    DESKTOP_SLUG,
    PAID_CITATIONS_SLUG,
    PARAPHRASING_TOOL_SLUG,
    SENTENCE_CHECKER_SLUG,
    PAID_PARAPHRASING_TOOL_SLUG,
    ESSAY_CHECKER_SLUG,
  ]).has(pageSlug)
}

export const isEligibleWorkweekWithAiBanner = (pageSlug: string) => {
  return [
    'business',
    'business/enterprise',
    'business/customer-support',
    'business/marketing',
    'business/it',
    'business/sales',
    'business/hr',
    'business/events-resources',
    'business/resources',
    'business/customer-stories',
    'ai',
    'ai/ai-business-resource-hub',
    'roi',
  ].includes(pageSlug)
}

export const isEligibleCompanyAnnouncement6_25Banner = (pageSlug: string) => {
  return [HOMEPAGE_SLUG, 'ai', 'ai-for-students', 'press', 'ai-writing-assistant'].includes(pageSlug)
}

export const isEligibleToolsSecondaryNav = (pageSlug: string) => {
  return [
    GRAMMAR_CHECK_SLUG,
    PLAGIARISM_CHECKER_SLUG,
    PARAPHRASING_TOOL_SLUG,
    AI_DETECTOR_SLUG,
    AI_HUMANIZER_SLUG,
  ].includes(pageSlug)
}

export const isEligibleForSchemaMarkup = (pageSlug: string) => {
  return [
    'ai/ai-writing-tools/article-writer',
    'ai/ai-writing-tools/brainstorming-generator',
    'ai/ai-writing-tools/conclusion-generator',
    'ai/ai-writing-tools/letter-generator',
    'ai/ai-writing-tools/paragraph-generator',
    'ai/ai-writing-tools/outline-generator',
    'ai/ai-writing-tools/paragraph-rewriter',
    'ai/ai-writing-tools/rewording-tool',
    'ai/ai-writing-tools/sentence-rewriter',
    'ai/ai-writing-tools/summarizing-tool',
    'ai/ai-writing-tools/title-generator',
    'ai/ai-writing-tools/cover-letter-generator',
    'ai/ai-writing-tools/linkedin-headline-generator',
    'ai/ai-writing-tools/resume-objective-generator',
    'ai/ai-writing-tools/resume-skills-generator',
    'ai/ai-writing-tools/business-plan-generator',
    'ai/ai-writing-tools/report-writer',
    'ai/ai-writing-tools/email-writer',
    'ai/ai-writing-tools/executive-summary-generator',
    'ai/ai-writing-tools/job-description-generator',
    'ai/ai-writing-tools/resignation-letter-generator',
    'ai/ai-writing-tools/value-proposition-generator',
    'ai/ai-writing-tools/blog-post-generator',
    'ai/ai-writing-tools/blog-post-title-generator',
    'ai/ai-writing-tools/business-name-generator',
    'ai/ai-writing-tools/headline-generator',
    'ai/ai-writing-tools/instagram-caption-generator',
    'ai/ai-writing-tools/linkedin-post-generator',
    'ai/ai-writing-tools/meta-description-generator',
    'ai/ai-writing-tools/meta-title-generator',
    'ai/ai-writing-tools/product-description-generator',
    'ai/ai-writing-tools/slogan-generator',
    'ai/ai-writing-tools/abstract-generator',
    'ai/ai-writing-tools/essay-title-generator',
    'ai/ai-writing-tools/personal-statement-generator',
    'ai/ai-writing-tools/poem-generator',
    'ai/ai-writing-tools/thesis-statement-generator',
    'grammar-check',
    'plagiarism-checker',
    'ai-detector',
    'citations',
    'sentence-checker',
    'spell-checker',
    'essay-checker',
    'word-counter',
  ].includes(pageSlug)
}
